import { useState, useRef } from "react";
import { Box, RadioButton, Checkbox } from "@flexisaf/flexibull2";
import styled from "styled-components";
import TinyEditor from "./tinyEditor";

import Theme from "../../theme";

const OptionInput = styled.div`
  border-radius: ${Theme.PrimaryRadius};
  border: 1px solid ${Theme.PrimaryBorderColor};
  width: 100%;
  & input {
    border: none;
    outline: none;
    height: 38px;
    width: 200px;
    padding: 0 10px;
    border-radius: ${Theme.PrimaryRadius};
    font-size: 12px;
  }

  & button {
    border: none;
    border-radius: 0 ${Theme.PrimaryRadius} ${Theme.PrimaryRadius} 0;
    background-color: ${Theme.PrimaryFade};
    color: ${Theme.PrimaryGrey};
    cursor: pointer;
    height: 38px;
    width: 38px;
  }
`;

export const OptionItem = ({
  option,
  editOption,
  deleteOption,
  disableDelete,
  setCorrectOption,
  isCorrectOption,
  provided,
  snapshot,
  questionType,
}) => {
  const [description, setDescription] = useState(option.text || "");
  const editorRef = useRef();

  return (
    <Box
      ref={provided.innerRef}
      {...provided.draggableProps}
      snapshot={snapshot}
      {...provided.dragHandleProps}
      display="flex"
      style={{
        alignItems: "start",

        display: "flex",
        flexDirection: "column",

        margin: "10px 0",
        ...provided.draggableProps.style,
      }}
    >
      {questionType === "SINGLE_CHOICE" && (
        <RadioButton
          checked={isCorrectOption}
          onChange={(e) => {
            if (e.target.checked) {
              setCorrectOption();
            }
          }}
          label="Correct answer"
        />
      )}

      {questionType === "MULTIPLE_CHOICE" && (
        <Checkbox
          label="Correct answer"
          checked={isCorrectOption}
          onChange={(e) => {
            if (e.target.checked) {
              setCorrectOption();
            }
          }}
        />
      )}

      <OptionInput>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <i className="saf-braille" style={{ color: Theme.PrimaryGrey }} />
          <button
            disabled={disableDelete}
            onClick={() => deleteOption(option.id)}
            style={{
              opacity: disableDelete ? 0.5 : 1,
              cursor: disableDelete ? "default" : "pointer",
            }}
          >
            <i className="saf-trash" style={{ fontSize: "18px" }} />
          </button>
        </div>
        <TinyEditor
          editorRef={editorRef}
          value={description}
          showMenuBar={false}
          height={200}
          onBlur={() => {
            editOption({
              ...option,
              text: description,
              correct: option?.correct || false,
            });
          }}
          onChange={(value) => {
            setDescription(value);
            editOption({
              ...option,
              text: description,
              correct: option?.correct || false,
            });
          }}
          toolbarItems="tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry | bold underline italic"
          controlled={true}
        />
      </OptionInput>
    </Box>
  );
};
